import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';
import { removeEmployeeLeaveRequest } from 'RestAPIs/employees/leave-requests';
import { useMutation, useQueryClient } from 'react-query';

const useRemoveLeaveRequest = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (leaveRequestId: number) => removeEmployeeLeaveRequest(leaveRequestId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('employeeLeaveRequests');
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useRemoveLeaveRequest;
